import { SEVEN_DAYS } from "@walletconnect/time";

export const SESSION_CONTEXT = "session";

export const SESSION_EXPIRY = SEVEN_DAYS;
